<template>
  <ResponseContainer :loading="!members">
    <h2 v-if="single">Do you have any dietary requirements?</h2>
    <h2 v-else>Does your party have any dietary requirements?</h2>
    <div v-for="m in members" :key="m" class="flex flex-col justify-between items-center border rounded p-4 mb-4 sm:flex-row">
      <div class="font-bold mb-2 sm:mb-0 sm:w-48 sm:text-left">{{ m.name }}</div>
      <input @blur="saveDietary(m.id)" v-model="m.dietary" type="text" name="dietary" placeholder="Dietary requirements" class="sm:mb-0">
    </div>
    <div class="sm:flex sm:flex-row sm:justify-between">
      <button @click="goToPrevious()" class="secondary-button">← Back</button>
      <button @click="goToNext()">Next →</button>
    </div>
  </ResponseContainer>
</template>

<script>
import ResponseContainer from '@/pages/ResponseContainer'
import Group from '@/models/group'

export default {
  name: 'ResponseExtraPage',
  components: {
    ResponseContainer,
  },
  data() {
    return {
      members: undefined,
      single: undefined,
    }
  },
  beforeMount() {
    this.loadParty()
  },
  methods: {
    async loadParty() {
      const group = await Group.current()
      this.members = await group.members
      this.members = this.members.filter(m => m.rsvp === true)
      this.single = this.members.length === 1
    },
    async saveDietary(guestId) {
      this.members.forEach(m => {
        if (m.id === guestId) {
          m.save()
        }
      })
    },
    goToNext() {
      this.$router.push('/rsvp/success')
    },
    goToPrevious() {
      this.$router.push('/rsvp/events')
    },
  },
}
</script>